import { Stack, Box } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";

export default function ContractNavItem() {
  return (
    <Stack
      flexDirection={"row"}
      alignItems={"center"}
      gap={1}
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "24px",
          height: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <BorderColorIcon sx={{ fontSize: 20, color: "inherit" }} />
      </Box>
      골프대행 계약서
    </Stack>
  );
}
